import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";
import Integration from "views/app-views/integration/integration";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "dashboard.default2",
    path: `${APP_PREFIX_PATH}/dashboards/default2`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/default/d2")
    ),
  },
  {
    key: "dashboard.default3",
    path: `${APP_PREFIX_PATH}/dashboards/default3`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/default/d3")
    ),
  },
  {
    key: "dashboard.alarms",
    path: `${APP_PREFIX_PATH}/alarms`,
    component: React.lazy(() => import("views/app-views/alarms/alarm")),
  },
  {
    key: "dashboard.messages",
    path: `${APP_PREFIX_PATH}/messages`,
    component: React.lazy(() => import("views/app-views/messages/messages")),
  },
  {
    key: "dashboard.integration",
    path: `${APP_PREFIX_PATH}/integration`,
    component: React.lazy(() =>
      import("views/app-views/integration/integration")
    ),
  },
  {
    key: "configuracoes.dynamic-content",
    path: `${APP_PREFIX_PATH}/api`,
    component: React.lazy(() => import("views/app-views/dynamic-content")),
  },
];
